import React, {Component} from 'react';
import StreamerPhoto from 'images/landing-ladder/streamers/streamer-photo.svg';
import TeamPhoto from 'images/landing-ladder/streamers/team-photo.svg';
import GamerInterface from 'app/interfaces/GamerInterface';
import {getImageDomain} from 'app/utils';

interface LandingLadderGameStreamerPhotoProps {
    gamer: GamerInterface
}

export default class LandingLadderGameStreamerPhoto extends Component<LandingLadderGameStreamerPhotoProps> {
    render(): React.ReactNode {
        const {gamer} = this.props;
        const defaultImg = gamer.is_player ? StreamerPhoto : TeamPhoto;

        return <span className={`streamer-photo${gamer.photo.src ? '' : ' avatar'}`}>
            <img
                src={gamer.photo.src ? `${getImageDomain()}/${gamer.photo.src}` : defaultImg}
                alt={gamer.nick}
                title={gamer.nick}
            />
        </span>;
    }
}
